/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SecurityScheme } from '../../openapi/v2/models/Oas20SecurityScheme';
import { NewSecuritySchemeCommand } from './NewSecuritySchemeCommand';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { Node } from '../../core/models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewSecuritySchemeCommand
 * @class
 */
export class NewSecuritySchemeCommand_20 extends NewSecuritySchemeCommand {
    public _nullSecurityDefinitions : boolean;

    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
            if(this._nullSecurityDefinitions===undefined) this._nullSecurityDefinitions = false;
            if(this._nullSecurityDefinitions===undefined) this._nullSecurityDefinitions = false;
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
            if(this._nullSecurityDefinitions===undefined) this._nullSecurityDefinitions = false;
            if(this._nullSecurityDefinitions===undefined) this._nullSecurityDefinitions = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand] Executing.");
        let doc20 : Oas20Document = <Oas20Document>document;
        this._nullSecurityDefinitions = false;
        if(this.isNullOrUndefined(doc20.securityDefinitions)) {
            doc20.securityDefinitions = doc20.createSecurityDefinitions();
            this._nullSecurityDefinitions = true;
        }
        if(this.isNullOrUndefined(doc20.securityDefinitions.getSecurityScheme(this._schemeName))) {
            let scheme : Oas20SecurityScheme = doc20.securityDefinitions.createSecurityScheme(this._schemeName);
            Library.readNode(this._scheme, scheme);
            doc20.securityDefinitions.addSecurityScheme(this._schemeName, scheme);
            this._schemeExisted = false;
        } else {
            this._schemeExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand] Reverting.");
        if(this._schemeExisted) {
            return;
        }
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this._nullSecurityDefinitions) {
            doc20.securityDefinitions = null;
            return;
        }
        doc20.securityDefinitions.removeSecurityScheme(this._schemeName);
    }
}
NewSecuritySchemeCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.NewSecuritySchemeCommand_20";
NewSecuritySchemeCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




